"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
var adjust_channel_1 = require("./adjust_channel");
/* LIGHTEN */
function lighten(color, amount) {
    return adjust_channel_1.default(color, 'l', amount);
}
/* EXPORT */
exports.default = lighten;



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/methods/lighten.js
// module id = 2187
// module chunks = 0